<template>
    <div class="reporting-restrictions-group">
        <div class="form-row">
            {{ restrictionGroup.name }}
        </div>

        <div v-for="(item, index) in restrictionGroup.items" :key="item.id">
            <reporting-restrictions-item :item="item" :user-id="user.id" :index="index" @item:delete="test(index)"></reporting-restrictions-item>
        </div>

        <div class="reporting-restrictions-group__add">
            <button @click.prevent="addItem" :title="trans('buttons.add')">
                <div class="icon-button icon-button--primary">
                    <div class="icon-button__icon">
                        <img src="/images/icons/create.svg" alt="">
                    </div>
                </div>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        'user': {
            type: Object,
            default: false
        },
        'restrictionGroup': {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            highestId: 0,
        };
    },

    methods: {
        test(index) {
            this.restrictionGroup.items.splice(index,1);
        },
        addItem() {
            var addItem = {};
            addItem.type = null;
            addItem.restriction = {};
            addItem.id = ++this.highestId;
            this.restrictionGroup.items.push(addItem);
        }
    },

    mounted() {
        if (this.restrictionGroup.items.length) {
            this.restrictionGroup.items.forEach(item => {
                if (item.id > this.highestId) {
                    this.highestId = item.id;
                }
            });
        }
    },
};
</script>
